import React from 'react'
import { graphql, Link } from 'gatsby'
import { Layout } from '../components/layout/layout'
import { Container, Grid, Paper, Typography } from '@material-ui/core'
import QuestionItem from '../pages/question'
import CategoryItem from '../pages/category'


const Category = ({ data, pageContext }) => {

  const pageData = data?.prismicPage?.data
  let { categories, question } = pageContext

  categories = categories && categories.filter(x => x && x.id)

  const pageProperties = {}
  if (question) {
    pageProperties["questionId"] = data?.prismicCategory?.data?.question?.id || question?.prismicId
  } else {
    pageProperties["categoryId"] = data?.prismicCategory?.id || pageContext?.prismicId
  }

  return (
    <Layout isNested={!!process.env.GATSBY_NESTED_FAQ}
      appbartext={pageData?.appbartext}
      footerbuttons={pageData?.footerbuttons}
      footertext={pageData?.footertext}
      footerctatext={pageData?.footerctatext}
      lang={data?.prismicPage?.lang}
      page={question ? "QuestionPage" : "CategoryPage"}
      pageProperties={pageProperties}
    >
      <Grid container spacing={1} alignItems="center" style={{ padding: "0 4px" }} >

        {categories && <Grid item xs={12} style={{}} >
          {
            categories.map(category => {
              return <CategoryItem item={category} key={category?.prismicId} lang={data?.prismicPage?.lang} />;
            })
          }
        </Grid>}
        {question && <Grid item xs={12} style={{}}>
          <QuestionItem item={question} answers={question?.data?.answers} lang={data?.prismicPage?.lang} />
        </Grid>}
      </Grid>
    </Layout>
  )
}
export default Category

export const categoryQuery = graphql`
  query CategoryQuery($lang: String!, $prismicId: ID!, $defaultPageId:ID!) {
  prismicCategory(lang: { eq: $lang }, prismicId: { eq: $prismicId }){
    lang
    id
    prismicId
    data{
      key{
        text
      }
      title{
        text
      }
      question{
        id
        type
        lang
      }
      categories{
        category{
          id
          type
          lang
        }
      }
    }
  }
  prismicPage(lang: { eq: $lang }, prismicId: { eq: $defaultPageId }){
    lang
    data{
      appbartext{
        text
      }
      footertext{
        text
      }
      footerctatext{
        text
      }
      footerbuttons{
        buttonicon{
          url
        }
        buttontext{
          text
        }
        buttonlink{
          url
        }
        buttontextcolor
        buttonbackgroundcolor
      }
    }
  }
}
`